var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{class:_vm.classes,attrs:{"height":_vm.height,"src":_vm.src}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }